import BellIcon from '@/assets/icons/content/bell-outline.svg';
import BellNotificationIcon from '@/assets/icons/content/bell-notification.svg';

import classes from '../Notifications.module.css';

interface NotificationsBadgeIconProps {
  totalNotifications: number;
}

const NotificationsBadgeIcon = ({ totalNotifications }: NotificationsBadgeIconProps) => (
  <div className={classes.badgeContainer}>
    {totalNotifications > 0 ? <BellNotificationIcon /> : <BellIcon />}
  </div>
);

export default NotificationsBadgeIcon;
